import React from "react";

const SideBarSvgSelector = ({ id }: { id: string }) => {
  switch (id) {
    case "side_link_01":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <g>
            <g>
              <g>
                <path
                  fill="#808080"
                  d="M15.99 10.988a6.5 6.5 0 0 0-8.974-8.974 8.476 8.476 0 0 0-1.976.349 7.534 7.534 0 0 1 1.663-1.33A7.465 7.465 0 0 1 10.479 0h.026a7.5 7.5 0 0 1 7.497 7.702l-.001.024a7.46 7.46 0 0 1-1.03 3.576 7.53 7.53 0 0 1-1.329 1.663c.19-.632.31-1.294.348-1.977z"
                />
              </g>
              <g>
                <path
                  fill="#808080"
                  d="M9.886 8.334a.5.5 0 1 1-.942.333A1.001 1.001 0 0 0 8 8v2a2 2 0 1 1 0 4v.5H7V14a2 2 0 0 1-1.886-1.333.5.5 0 1 1 .942-.333c.138.389.509.666.944.666v-2a2 2 0 1 1 0-4v-.5h1V7a2 2 0 0 1 1.886 1.334zM7 8a1 1 0 0 0 0 2zm1 5a1 1 0 0 0 0-2z"
                />
              </g>
              <g>
                <path
                  fill="#808080"
                  d="M15 10.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0zM7.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "side_link_02":
      return (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.60948 9.5C8.60948 9.73621 8.70331 9.96274 8.87034 10.1298C9.03736 10.2968 9.2639 10.3906 9.50011 10.3906C9.73631 10.3906 9.96285 10.2968 10.1299 10.1298C10.2969 9.96274 10.3907 9.73621 10.3907 9.5C10.3907 9.26379 10.2969 9.03726 10.1299 8.87023C9.96285 8.70321 9.73631 8.60938 9.50011 8.60938C9.2639 8.60938 9.03736 8.70321 8.87034 8.87023C8.70331 9.03726 8.60948 9.26379 8.60948 9.5V9.5ZM12.3204 9.5C12.3204 9.73621 12.4143 9.96274 12.5813 10.1298C12.7483 10.2968 12.9748 10.3906 13.211 10.3906C13.4473 10.3906 13.6738 10.2968 13.8408 10.1298C14.0078 9.96274 14.1017 9.73621 14.1017 9.5C14.1017 9.26379 14.0078 9.03726 13.8408 8.87023C13.6738 8.70321 13.4473 8.60938 13.211 8.60938C12.9748 8.60938 12.7483 8.70321 12.5813 8.87023C12.4143 9.03726 12.3204 9.26379 12.3204 9.5ZM4.89854 9.5C4.89854 9.73621 4.99238 9.96274 5.1594 10.1298C5.32643 10.2968 5.55296 10.3906 5.78917 10.3906C6.02538 10.3906 6.25191 10.2968 6.41893 10.1298C6.58596 9.96274 6.67979 9.73621 6.67979 9.5C6.67979 9.26379 6.58596 9.03726 6.41893 8.87023C6.25191 8.70321 6.02538 8.60938 5.78917 8.60938C5.55296 8.60938 5.32643 8.70321 5.1594 8.87023C4.99238 9.03726 4.89854 9.26379 4.89854 9.5V9.5ZM17.1669 6.27891C16.7476 5.28252 16.1464 4.38818 15.3801 3.62002C14.6191 2.8563 13.7158 2.24924 12.7212 1.8332C11.7007 1.40459 10.6171 1.1875 9.50011 1.1875H9.463C8.33858 1.19307 7.24942 1.41572 6.2252 1.85361C5.23913 2.27392 4.34425 2.88206 3.59044 3.64414C2.83155 4.41045 2.23595 5.30107 1.82403 6.29375C1.39727 7.32168 1.18204 8.41455 1.18761 9.53896C1.1939 10.8275 1.49875 12.0971 2.07823 13.248V16.0684C2.07823 16.2947 2.16815 16.5118 2.32822 16.6719C2.48828 16.832 2.70538 16.9219 2.93175 16.9219H5.75391C6.90485 17.5014 8.17443 17.8062 9.463 17.8125H9.50196C10.6134 17.8125 11.6914 17.5973 12.7064 17.1761C13.6959 16.765 14.5959 16.165 15.356 15.4097C16.1223 14.6508 16.7253 13.7639 17.1465 12.7749C17.5844 11.7507 17.807 10.6615 17.8126 9.53711C17.8182 8.40713 17.5992 7.31055 17.1669 6.27891V6.27891ZM14.3633 14.4059C13.0626 15.6936 11.337 16.4023 9.50011 16.4023H9.46856C8.34971 16.3968 7.23829 16.1185 6.25675 15.5952L6.10089 15.5117H3.48839V12.8992L3.40489 12.7434C2.88165 11.7618 2.60333 10.6504 2.59776 9.53154C2.59034 7.68164 3.29727 5.94492 4.59425 4.63682C5.88936 3.32871 7.62052 2.60508 9.47042 2.59766H9.50196C10.4297 2.59766 11.3296 2.77764 12.1775 3.13389C13.0051 3.48086 13.7473 3.97998 14.3856 4.61826C15.022 5.25469 15.523 5.99873 15.8699 6.82627C16.2299 7.6835 16.4099 8.59268 16.4062 9.53154C16.395 11.3796 15.6695 13.1107 14.3633 14.4059V14.4059Z"
            fill="#808080"
          />
        </svg>
      );
    case "side_link_03":
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.59375 7C4.59375 6.36182 4.84726 5.74978 5.29852 5.29852C5.74978 4.84726 6.36182 4.59375 7 4.59375C7.63818 4.59375 8.25022 4.84726 8.70148 5.29852C9.15274 5.74978 9.40625 6.36182 9.40625 7C9.40625 7.63818 9.15274 8.25022 8.70148 8.70148C8.25022 9.15274 7.63818 9.40625 7 9.40625C6.36182 9.40625 5.74978 9.15274 5.29852 8.70148C4.84726 8.25022 4.59375 7.63818 4.59375 7ZM7 3.5C6.07174 3.5 5.1815 3.86875 4.52513 4.52513C3.86875 5.1815 3.5 6.07174 3.5 7C3.5 7.92826 3.86875 8.8185 4.52513 9.47487C5.1815 10.1313 6.07174 10.5 7 10.5C7.92826 10.5 8.8185 10.1313 9.47487 9.47487C10.1313 8.8185 10.5 7.92826 10.5 7C10.5 6.07174 10.1313 5.1815 9.47487 4.52513C8.8185 3.86875 7.92826 3.5 7 3.5ZM13.3438 7.875C13.3438 7.46889 13.5051 7.07941 13.7922 6.79224C14.0794 6.50508 14.4689 6.34375 14.875 6.34375C15.2811 6.34375 15.6706 6.50508 15.9578 6.79224C16.2449 7.07941 16.4062 7.46889 16.4062 7.875C16.4062 8.28111 16.2449 8.67059 15.9578 8.95776C15.6706 9.24492 15.2811 9.40625 14.875 9.40625C14.4689 9.40625 14.0794 9.24492 13.7922 8.95776C13.5051 8.67059 13.3438 8.28111 13.3438 7.875ZM14.875 5.25C14.1788 5.25 13.5111 5.52656 13.0188 6.01884C12.5266 6.51113 12.25 7.17881 12.25 7.875C12.25 8.57119 12.5266 9.23887 13.0188 9.73116C13.5111 10.2234 14.1788 10.5 14.875 10.5C15.5712 10.5 16.2389 10.2234 16.7312 9.73116C17.2234 9.23887 17.5 8.57119 17.5 7.875C17.5 7.17881 17.2234 6.51113 16.7312 6.01884C16.2389 5.52656 15.5712 5.25 14.875 5.25ZM14.875 17.0625C13.923 17.0625 13.1591 16.9085 12.5492 16.6591L12.6306 16.5541C12.8468 16.2693 13.0126 15.9841 13.1394 15.7137C13.5857 15.869 14.1527 15.9688 14.8746 15.9688C16.7453 15.9688 17.5753 15.2981 17.9646 14.7302C18.1864 14.4039 18.3253 14.0285 18.3693 13.6364C18.3718 13.6108 18.3736 13.5852 18.3746 13.5594V13.4531C18.3746 13.1512 18.1296 12.9062 17.8277 12.9062H13.5026C13.4127 12.5019 13.2241 12.1261 12.9535 11.8125H17.8281C18.2632 11.8125 18.6805 11.9854 18.9882 12.293C19.2959 12.6007 19.4688 13.018 19.4688 13.4531V13.5831L19.4674 13.6207C19.4657 13.6513 19.4631 13.6924 19.4587 13.7428C19.3966 14.3184 19.1936 14.8699 18.8676 15.3484C18.2442 16.2562 17.0507 17.0625 14.8741 17.0625H14.875ZM2.95312 11.8125C2.518 11.8125 2.1007 11.9854 1.79303 12.293C1.48535 12.6007 1.3125 13.018 1.3125 13.4531V14.0232L1.31425 14.0656C1.316 14.1006 1.3195 14.147 1.32562 14.2047C1.33831 14.3194 1.36237 14.4769 1.40962 14.6641C1.53501 15.1573 1.75817 15.6203 2.06588 16.0256C2.83456 17.0389 4.29888 17.9375 7 17.9375C9.70156 17.9375 11.1659 17.0389 11.9337 16.0256C12.2416 15.6202 12.4649 15.1571 12.5904 14.6637C12.6376 14.4769 12.6617 14.3194 12.6744 14.2043C12.681 14.1441 12.6854 14.0837 12.6875 14.0232V13.4531C12.6875 13.2377 12.6451 13.0243 12.5626 12.8253C12.4802 12.6262 12.3593 12.4454 12.207 12.293C12.0546 12.1407 11.8738 12.0198 11.6747 11.9374C11.4757 11.8549 11.2623 11.8125 11.0469 11.8125H2.95312ZM2.40669 14.0105L2.40625 13.9965V13.4531C2.40625 13.1512 2.65125 12.9062 2.95312 12.9062H11.0469C11.3488 12.9062 11.5938 13.1512 11.5938 13.4531V13.9965L11.5933 14.0105C11.5834 14.1404 11.5623 14.2692 11.5303 14.3955C11.4408 14.7468 11.2816 15.0764 11.0622 15.365C10.5451 16.0475 9.43906 16.8438 7 16.8438C4.56094 16.8438 3.45494 16.0475 2.93781 15.365C2.71847 15.0766 2.55928 14.747 2.46969 14.3959C2.43768 14.2695 2.4166 14.1405 2.40669 14.0105Z"
            fill="#808080"
          />
        </svg>
      );
    case "side_link_04":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <g>
            <g>
              <g />
              <g>
                <path
                  fill="gray"
                  d="M16.484 2.868c.108.202.165.427.166.656v9.574a1.406 1.406 0 0 1-.619 1.125 1.45 1.45 0 0 1-.787.247c-.181 0-.36-.034-.529-.1l-6.84-2.734v2.846a1.406 1.406 0 0 1-1.395 1.406h-.709a1.417 1.417 0 0 1-1.271-.81l-1.687-3.577a1.406 1.406 0 0 1-1.407-1.373v-.146H0V6.607h1.406v-.113a1.406 1.406 0 0 1 1.407-1.406h4.443c.178 0 .353-.034.518-.101l6.941-2.734a1.406 1.406 0 0 1 1.316.113c.19.128.345.3.453.502zM2.812 6.494v3.634H6.47V6.494zm3.657 5.007H4.376l1.384 2.98h.709zm8.775 1.563v-9.54L8.29 6.292a2.542 2.542 0 0 1-.416.124v3.712c.143.044.283.1.416.169zm1.44-6.176a1.406 1.406 0 0 1 0 2.813z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "side_link_05":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.1646 1.47719L6.31242 7.32937C3.8636 9.78434 2.00915 12.7672 0.891111 16.0495C0.837793 16.2048 0.829301 16.3719 0.866609 16.5318C0.903918 16.6916 0.985515 16.8377 1.10205 16.9533L1.10511 16.9564C1.1862 17.0381 1.28265 17.103 1.3889 17.1473C1.49516 17.1916 1.60912 17.2144 1.72424 17.2145C1.82111 17.2144 1.91731 17.1985 2.00901 17.1672C5.29133 16.0492 8.27421 14.1948 10.7292 11.7459L16.5812 5.89376C17.1668 5.30809 17.4959 4.51375 17.4959 3.68549C17.4959 2.85722 17.1669 2.06288 16.5812 1.47721C16.2912 1.18721 15.9469 0.957173 15.568 0.800227C15.1891 0.643281 14.783 0.562502 14.3729 0.5625C13.5446 0.562497 12.7503 0.891521 12.1646 1.47719ZM9.93351 10.9504C7.72159 13.1566 5.05747 14.8567 2.12488 15.9335C3.20169 13.0009 4.90178 10.3368 7.1079 8.12485L10.5941 4.63872L13.4196 7.4643L9.93351 10.9504ZM15.7857 5.09828L14.2151 6.66882L11.3895 3.84324L12.9601 2.27267C13.1455 2.0867 13.3658 1.93911 13.6084 1.83834C13.8509 1.73757 14.1109 1.68561 14.3735 1.68542C14.6361 1.68523 14.8962 1.73682 15.1389 1.83724C15.3816 1.93765 15.6021 2.08492 15.7878 2.27063C15.9735 2.45634 16.1207 2.67683 16.2212 2.9195C16.3216 3.16217 16.3731 3.42226 16.373 3.68489C16.3728 3.94751 16.3208 4.20752 16.22 4.45005C16.1193 4.69257 15.9717 4.91285 15.7857 5.09828Z"
            fill="gray"
          />
        </svg>
      );

    case "side_link_06":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
        >
          <g>
            <g>
              <g />
              <g>
                <path
                  fill="gray"
                  d="M14.352 17.947c-.234 0-.461-.07-.655-.201L9.76 15.107a.116.116 0 0 0-.132 0l-3.937 2.639a1.172 1.172 0 0 1-1.784-1.272l1.293-4.56a.121.121 0 0 0-.042-.127L1.432 8.858a1.172 1.172 0 0 1 .68-2.11l4.75-.18a.121.121 0 0 0 .106-.08L8.604 2.04a1.172 1.172 0 0 1 2.201 0l1.636 4.45a.122.122 0 0 0 .106.079l4.75.18a1.172 1.172 0 0 1 .68 2.11l-3.726 2.93a.116.116 0 0 0-.042.126l1.293 4.56a1.179 1.179 0 0 1-1.15 1.472zM9.697 14.03c.233.008.46.085.649.222l3.937 2.639a.116.116 0 0 0 .181-.059.116.116 0 0 0-.002-.073l-1.293-4.56a1.165 1.165 0 0 1 .407-1.24l3.726-2.93a.116.116 0 0 0-.069-.21l-4.75-.18a1.172 1.172 0 0 1-1.055-.77l-1.636-4.45a.116.116 0 0 0-.222 0L7.95 6.863a1.172 1.172 0 0 1-1.056.77l-4.75.18a.116.116 0 0 0-.068.211l3.731 2.935a1.172 1.172 0 0 1 .406 1.24l-1.287 4.56a.11.11 0 0 0 .042.127.105.105 0 0 0 .137 0l3.937-2.64c.193-.127.419-.195.65-.194z"
                />
              </g>
              <g />
            </g>
          </g>
        </svg>
      );
    case "side_link_07":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <g>
            <g>
              <g />
              <g>
                <path
                  fill="#808080"
                  d="M12.16 1.475a3.123 3.123 0 0 1 4.417 4.416l-5.852 5.852a22.72 22.72 0 0 1-8.72 5.422.884.884 0 0 1-.62-.02.873.873 0 0 1-.284-.191l-.003-.003a.874.874 0 0 1-.21-.904 22.721 22.721 0 0 1 5.42-8.72l5.853-5.852zm1.256 5.987L10.59 4.636 7.104 8.122a21.601 21.601 0 0 0-4.983 7.809 21.6 21.6 0 0 0 7.809-4.983zm2.366-2.366a1.998 1.998 0 1 0-2.826-2.826l-1.57 1.57 2.825 2.826z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "side_link_08":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <g>
            <g>
              <g />
              <g>
                <path fill="gray" d="M8.13 9.38v5l4.375-2.5z" />
              </g>
              <g>
                <path
                  fill="gray"
                  d="M3.75 17.5a1.25 1.25 0 0 1-1.25-1.25V7.5a1.251 1.251 0 0 1 1.25-1.25h12.5A1.251 1.251 0 0 1 17.5 7.5v8.75a1.25 1.25 0 0 1-1.25 1.25zm0-10v8.75h12.5V7.5zm0-3.75h12.5V5H3.75zM5 1.25h10V2.5H5z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "side_link_09":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <g>
            <g>
              <g />
              <g>
                <path
                  fill="gray"
                  d="M14.375 7.505a4.39 4.39 0 0 1-1.934 3.632c2.23.958 3.809 3.17 3.809 5.743H15c0-2.769-2.231-5-5-5a4.99 4.99 0 0 0-5 5H3.75c0-2.573 1.58-4.786 3.809-5.742a4.39 4.39 0 0 1-1.934-3.633A4.384 4.384 0 0 1 10 3.13a4.384 4.384 0 0 1 4.375 4.375zm-7.5 0A3.116 3.116 0 0 0 10 10.63a3.116 3.116 0 0 0 3.125-3.125A3.116 3.116 0 0 0 10 4.38a3.116 3.116 0 0 0-3.125 3.125z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "news":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_116)">
            <path
              d="M5.25 12.75H9M16.5 9C16.5 13.1422 13.1422 16.5 9 16.5H1.5V9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9ZM5.25 6.75H12H5.25ZM5.25 9.75H12H5.25Z"
              stroke="#909090"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_116">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "home":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.125 8.3125L10 2.5L16.875 8.3125V16.25C16.875 16.5815 16.7435 16.8995 16.5083 17.1348C16.273 17.37 15.9551 17.5015 15.625 17.5015H4.375C4.04458 17.5015 3.72668 17.37 3.49144 17.1348C3.2562 16.8995 3.125 16.5815 3.125 16.25V8.3125Z"
            stroke="#808080"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 17.5V10H12.5V17.5"
            stroke="#808080"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return <svg></svg>;
  }
};

export default SideBarSvgSelector;
